import logo from "./logo.svg";
import "./App.css";
import React from "react";
import { Router, Route } from "react-router-dom";
import { PrivateRoute } from "./_components";
import { history } from "./_helpers";
import { MainPage } from "./MainPage";
import { PurchasedPage } from "./MainPage/PurchasedPage";
import { LoginPage, RegistrPage, OAuthPage, OAuthStartPage } from "./LoginPage";
import AgrPage from "./LoginPage/AgrPage";
import VerifyPage from "./LoginPage/VerifyPage";
import { ClientConfPage, ClientListPage } from "./ClientPages";
import PasswordResetPage from "./LoginPage/PasswordResetPage";
import PasswordForgotPage from "./LoginPage/PasswordForgotPage";
import ModerationPage from "./LoginPage/ModerationPage";
import { VotingPage } from "./ClientPages/VotingPage";
import { VoteResPage } from "./ClientPages/VoteResPage";
import { CheckCodePage } from "./ClientPages/CheckCodePage.js";
import { QrCodePage } from "./ClientPages/QrCodePage.js";
import { ChinaModeGate } from "./_components";
import { ChinaExitPage } from "./LoginPage";

const routes = [
  "/conf_param",
  "/conf_prog",
  "/team_org",
  "/role_org",
  "/new_conf",
  "/blds",
  "/speakers",
  "/sponsors",
  "/nav",
  "/client_view",
  "/partips",
  "/conf_view",
  "/tickets",
  "/settings",
  "/support",
  "/tasks",
  "/mailings",
  "/confpartips",
  "/anketa-fields",
  "/orders",
  "/ticket-moderation",
  "/votelist",
  "/newvote",
  "/userlist",
  "/new_site",
  "/booking",
  "/sites",
  "/statistics",
];

const routes_id = [
  "/conf_param/:id",
  "/conf_prog/:id",
  "/nav/:id",
  "/client_view/:id",
  "/partips/:id",
  "/conf_view/:id",
  "/editvote/:id",
  "/site_param/:id",
  "/site_view/:id",
  "/mailings/:id",
  "/confpartips/:id",
  "/statistics/:id",
  
];

export class App extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    document.title = "NaviConf";
  }

  render() {
    return (
      <Router history={history}>
        <Route path="/login" component={LoginPage} />
        <Route path="/registration" component={RegistrPage} />
        <Route path="/agreement" component={AgrPage} />
        <Route path="/email-verified" component={VerifyPage} />
        <Route path="/password-reset" component={PasswordResetPage} />
        <Route path="/password-forgot" component={PasswordForgotPage} />
        {/* Открывается в браузере телефона по просьбе мобильного приложения — в сборке
            режима «визитка» этой страницы намеренно нет. */}
        <Route path="/oauth-start" component={OAuthStartPage} />
        <Route path="/vkontakte-callback" render={(props) => (
          <OAuthPage {...props} oauthService="vkontakte" />
        )} />
        <Route path="/alipay-callback" render={(props) => (
          <OAuthPage {...props} oauthService="alipay" />
        )} />
        <Route path="/leaderid-callback" render={(props) => (
          <OAuthPage {...props} oauthService="leader-id" />
        )} />
        <Route path="/yandex-callback" render={(props) => (
          <OAuthPage {...props} oauthService="yandex" />
        )} />
        <Route path="/sber-callback" render={(props) => (
          <OAuthPage {...props} oauthService="sber-id" />
        )} />
        <Route path="/exit" component={ChinaExitPage} />

        <ChinaModeGate>
          <Route path="/event/:id" component={ClientConfPage} />
          <Route path="/events" component={ClientListPage} />
          <Route path="/qrcode/:id" component={QrCodePage} />
          <Route path="/votes/:id" component={VotingPage} />
          <Route path="/voteres/:id" component={VoteResPage} />
          <Route path="/checkcode/:id" component={CheckCodePage} />
          <Route path="/purchased-:id" component={PurchasedPage} />
          <PrivateRoute exact path="/" component={MainPage} />
          <Route path="/ticket-moderation" component={ModerationPage} />
          {routes.map((item, index) => (
            <PrivateRoute exact path={item} component={MainPage} key={index} />
          ))}
          {routes_id.map((item, index) => (
            <PrivateRoute path={item} component={MainPage} key={1000 + index} />
          ))}
        </ChinaModeGate>
      </Router>
    );
  }
}

export default App;
